
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'SectionHeader',
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: '',
    },
    alignment: {
      type: String,
      default: 'center',
      validator: (value: string) => ['left', 'center', 'right'].includes(value),
    },
    theme: {
      type: String,
      default: 'dark',
      validator: (value: string) => ['dark', 'light'].includes(value),
    },
    maxWidth: {
      type: String,
      default: '800px',
    },
    spacing: {
      type: String,
      default: 'fc-margin-bottom-8',
    },
  },
});
